webpackJsonp([182123141176091],{

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIframe = __webpack_require__(52);
	
	var _reactIframe2 = _interopRequireDefault(_reactIframe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	        var width = _ref.width,
	            height = _ref.height,
	            src = _ref.src;
	        return _react2.default.createElement(_reactIframe2.default, {
	                width: width,
	                height: height,
	                url: src,
	                display: 'initial',
	                position: 'relative',
	                allowFullScreen: true });
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 195:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"AddressBock":"src-layouts----Pages-module---AddressBock---1KhHS","Address":"src-layouts----Pages-module---Address---KDR6o","Cancellation":"src-layouts----Pages-module---Cancellation---ry8Zz","CancellationItem":"src-layouts----Pages-module---CancellationItem---2tIaP","AddressBockMap":"src-layouts----Pages-module---AddressBockMap---2XvyW"};

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Footer = __webpack_require__(79);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Iframe = __webpack_require__(64);
	
	var _Iframe2 = _interopRequireDefault(_Iframe);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PagesModule = __webpack_require__(195);
	
	var _PagesModule2 = _interopRequireDefault(_PagesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class() {
	        _classCallCheck(this, _class);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    _class.prototype.render = function render() {
	        var deviceWidth = this.props.gDeviceWidth;
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement('html', { lang: 'en' }),
	                _react2.default.createElement(
	                    'title',
	                    null,
	                    'Contact us at 613-252-5227 or book an appointment online.'
	                ),
	                _react2.default.createElement('meta', { name: 'description', content: 'We take consultations from 9AM to 12PM and from 1PM to 5PM. Don\'t hesitate to contact us to book an appointment or for more information' })
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { style: { maxWidth: 1170, padding: '20px', margin: 'auto' } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _PagesModule2.default.Address },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _PagesModule2.default.AddressBock, style: { display: 'flex', alignItems: 'center', padding: 0 } },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'h1',
	                                    null,
	                                    'Contact Us'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(
	                                        'strong',
	                                        null,
	                                        'CPM: Center for Psychotromatology and Mediation'
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { style: { color: '#1689DF' } },
	                                        'Monday - Friday: 9AM - 12PM & 1PM - 5PM'
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    '427 McArthur Ave, 2e Floor, Suite #3',
	                                    _react2.default.createElement('br', null),
	                                    'Ottawa (ON) K1K 1G5, Canada',
	                                    _react2.default.createElement('br', null),
	                                    'T\xE9l. +1 (613) 252-5227',
	                                    _react2.default.createElement('br', null),
	                                    'E-mail: info@cpm-ca.org',
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                        _gatsbyLink2.default,
	                                        { to: '/en/booking' },
	                                        _react2.default.createElement(
	                                            'em',
	                                            null,
	                                            _react2.default.createElement(
	                                                'strong',
	                                                null,
	                                                'ou Book an Appointment Online'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _PagesModule2.default.AddressBockMap },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(_Iframe2.default, { width: '100%', height: '' + (deviceWidth > 767 ? "400px" : '300px'), src: 'https://www.google.com/maps/embed/v1/place?key=AIzaSyD5d58sVD8JymoPG0mWxmQP8glK9_m9cI4&q=427+McArthur+Ave,Ottawa,ON' })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _PagesModule2.default.Cancellation },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _PagesModule2.default.CancellationItem },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'Cancel an Appointment'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'If you cancel or reschedule your first appointment with less than 48 hours notice, or if you do not show up, you will be charged the full amount of the consultation.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _PagesModule2.default.CancellationItem },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'Reimbursement'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'All our consultations can be partially or totally reimbursed by certain insurances. For further information please contact the secretariat.'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(_Footer2.default, null)
	        );
	    };
	
	    return _class;
	}(_react.Component);
	
	exports.default = _class;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-en-contact-js-7b1fe9c5e11fcc1f3813.js